// extracted by mini-css-extract-plugin
export var infoRow = "_rc-2";
export var labelContainer = "_rc-0";
export var rightInfo = "_rc-1";